import { repeatSalePotentials, RepeatSalePotential, totalRepeatPotential } from "@/mocks/rop";

function formatMoney(value: number): string {
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(value);
}

interface RepeatSalesModalProps {
  onClose: () => void;
}

export default function RepeatSalesModal({ onClose }: RepeatSalesModalProps) {
  return (
    <div className="fixed inset-0 bg-foreground-950/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg border border-[#D5CA8A] w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 bg-[#FEF3C7] border-b border-[#D5CA8A] rounded-t-lg">
          <div className="flex items-center gap-2">
            <i className="ri-refresh-line text-[#2D6A4F]"></i>
            <span className="text-[12px] font-semibold text-[#2D2D2D]">Повторные продажи и потенциал возврата ({repeatSalePotentials.length})</span>
            <span className="text-[10px] text-[#2D6A4F] ml-2">Потенциал: {formatMoney(totalRepeatPotential)}</span>
          </div>
          <button onClick={onClose} className="w-6 h-6 flex items-center justify-center rounded hover:bg-[#E8DB6C] cursor-pointer">
            <i className="ri-close-line text-[#666666]"></i>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <div className="grid grid-cols-1 gap-3">
            {repeatSalePotentials.map((p: RepeatSalePotential) => (
              <div key={p.client} className="p-3 border border-[#D5CA8A] rounded-lg hover:bg-[#FDF2B5]/20 transition-colors">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-[11px] font-semibold text-[#2D2D2D]">{p.client.replace("ООО ", "").replace("АО ", "")}</span>
                  <span className="px-1.5 py-0.5 rounded bg-[#D4EDDA] text-[#2D6A4F] text-[9px]">{p.category}</span>
                </div>
                <p className="text-[10px] text-[#666666] mb-2">{p.reason}</p>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-1 text-[10px]">
                    <span className="text-[#666666]">Было:</span>
                    <span className="text-[#2D2D2D] font-medium">{formatMoney(p.previousRevenue)}</span>
                  </div>
                  <div className="flex items-center gap-1 text-[10px]">
                    <span className="text-[#666666]">Потенциал:</span>
                    <span className="text-[#2D6A4F] font-medium">{formatMoney(p.potentialRevenue)}</span>
                  </div>
                  <span className="text-[10px] text-[#666666] ml-auto">{p.manager}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4 p-3 bg-[#FEF3C7] rounded-lg">
            <p className="text-[11px] font-semibold text-[#2D2D2D] mb-1">Рекомендации AI</p>
            <p className="text-[10px] text-[#666666]">
              Общий потенциал повторных продаж: {formatMoney(totalRepeatPotential)}. Наибольший потенциал у ООО Швейное Объединение Восток ({formatMoney(1800000)}) —
              персонализированное КП на трикотаж может вернуть клиента к прежним объемам. Рекомендуется запустить программу реактивации с индивидуальными условиями для каждого клиента.
            </p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 px-4 py-3 border-t border-[#D5CA8A] bg-[#FFF9E6] rounded-b-lg">
          <button onClick={onClose} className="px-3 py-1.5 rounded text-[11px] text-[#666666] hover:bg-[#FDF2B5] cursor-pointer transition-colors whitespace-nowrap">
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}